<template lang="pug">
  .usermenu(
    v-if="isActive"
  )
    ul
      li.usermenu__item
        router-link.usermenu__link(@click.native="hideUsernav" :to="{name: 'account'}")
          font-awesome-icon.usermenu__icon(icon="user")
          | Профиль
      li.usermenu__item
        router-link.usermenu__link(@click.native="hideUsernav" :to="{name: 'settings'}")
          font-awesome-icon.usermenu__icon(icon="cog")
          | Настройки
      li.usermenu__item
        a(href="#").usermenu__link(@click="logout")
          font-awesome-icon.usermenu__icon(icon="sign-out-alt")
          | Выход
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCog, faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

library.add(faCog, faSignOutAlt, faUser);

export default {
  data() {
    return {
      isActive: false
    };
  },

  methods: {
    hide() {
      this.isActive = false;
    },

    show() {
      this.isActive = true;
    },

    toggle() {
      this.isActive = !this.isActive;
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'login' });
      });
    }
  },

  components: {
    FontAwesomeIcon
  },

  directives: {
    ClickOutside
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';

.usermenu {
  display: flex;
  margin-left: auto;
  background-color: #fff;
  border: 1px solid _palette(borders, base);
  width: 200px;
  position: absolute;
  z-index: 100;
  right: 0;
  top: 100%;

  ul {
    @extend %ul-reset;
    display: block;
    width: 100%;
  }

  &__item {
    display: block;
    border-bottom: 1px solid _palette(borders, base);

    &:last-child {
      border-bottom: none;
    }
  }

  &__icon {
    margin-right: 5px;
  }

  &__link,
  &__link--logout {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 10px;
  }

  &__item--logout {
    padding: 10px;
  }
}
</style>
